import { useRef, useState, useEffect } from 'react';
import Header from './Header';
import Grid from './Grid';

const MicroficheScreenContents = (props) => {

  const { siteData, selectedPageNumber, selectedLayer, selectedLocation, sortBy, setMicrofichePagesLength, screenContents } = props;
  const { fragments } = siteData;
  const [items, setItems] = useState([]);
	const viewArchiveInner = useRef();

	const [ allItems, setAllItems ] = useState([]);

  useEffect(() => {
    if (fragments?.entries) {

      const itemsArray = [];

      for (let entry of fragments.entries) {
        if (entry.content) {
          for (let contentItem of entry.content) {
            const newContentItem = {
              layers: [...entry.layers],
              locations: [...entry.locations],
              location: { ...entry.location },
              title: entry.title,
              _created: entry._created,
              _id: entry._id,
              content: { ...contentItem }
            }
            itemsArray.push(newContentItem);
          }
        }
      }
      setAllItems([...itemsArray]);
    }
  }, [fragments]);

  useEffect(() => {
    if (allItems[0]) {

      const itemsPerPageNumber = 12 * 3;

      const newItemsArray = [];

      for (let item of allItems) {
        let matchesLayer = true;
        let matchesLocation = true;

        if (selectedLayer._id) {
          matchesLayer = false;
          if (item.layers) {
            for (let layer of item.layers) {
              if (layer._id === selectedLayer._id) {
                matchesLayer = true;
              }
            }
          }
        }

        if (selectedLocation._id) {
          matchesLocation = false;
          if (item.locations) {
            for (let location of item.locations) {
              if (location._id === selectedLocation._id) {
                matchesLocation = true;
              }
            }
          }
        }

        if (matchesLayer === true && matchesLocation === true) {
          newItemsArray.push({...item });
        }
      }

      const numberOfPages = ((newItemsArray.length - (newItemsArray.length % itemsPerPageNumber)) / itemsPerPageNumber + 1);
      setMicrofichePagesLength && setMicrofichePagesLength(numberOfPages);

      let newShownItemsArray = [];
      for (let i = selectedPageNumber * itemsPerPageNumber; i < Math.min(newItemsArray.length, (selectedPageNumber + 1) * itemsPerPageNumber); i++) {
        newShownItemsArray.push({...newItemsArray[i]});
      }

      if (sortBy === 'chronologically') {
        newShownItemsArray = newShownItemsArray.sort((a, b) => (a._created > b._created) ? -1 : 1);
      } else if (sortBy === 'reverse chronologically') {
        newShownItemsArray = newShownItemsArray.sort((a, b) => (a._created > b._created) ? 1 : -1);
      } else if (sortBy === 'alphabetically') {
        newShownItemsArray = newShownItemsArray.sort((a, b) => (a.title > b.title) ? 1 : -1);
      } else {
        newShownItemsArray = newShownItemsArray.sort((a, b) => (a.title > b.title) ? -1 : 1);
      }

      setItems([...newShownItemsArray]);
    }
  }, [allItems, selectedLayer, selectedLocation, selectedPageNumber, setMicrofichePagesLength, sortBy]);


  return (
    <div className="microfiche-viewer">
      <div
        ref={viewArchiveInner}
        className={`view--archive__inner view--archive__inner--hidden`}
      >
        <div
          className="archive__content"
        >
          <div
            className="archive__content__inner"
            ref={screenContents}
            style={{
              width: '100%',
              height: '846px'
            }}
					>
            <Header items={items} {...props} />
						<Grid
							key={`${selectedPageNumber} ${selectedLocation?._id ?? ''} ${selectedLayer?._id ?? ''} ${sortBy}`}
              itemsArray={items}
              {...props}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MicroficheScreenContents;